import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BaseHttpClientService } from './base-http-client.service';

@Injectable()
export class SiteWorkersService extends BaseHttpClientService {

  constructor(
    private http: HttpClient,
  ) {
    super()
  }

  /**
   * Get all the works using sort condition and filters
   * @param siteId
   * @param pagination
   * @param sort
   * @param filters
   * @returns
   */
  public getAllWorkerForSiteWithFilters(siteId, pagination, sort, filter) {
    const params = this.createQueryStrings(pagination, sort, filter);
    const headers = this.applyLatestOnlyHeader();

    return this.http.get(environment.apiUrl + 'api/ext-worker-user-site/by-site/' + siteId + '/list', { params: params, observe: 'response', headers: headers })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  // Add Worker to a site
  public addWorkerToSite(obj) {
    return this.http.post(environment.apiUrl + 'api/ext-worker-user-site/create', obj)
      .pipe(catchError(this.handleError));
  }

  // Edit Site worker
  public editSiteWorker(obj) {
    return this.http.put(environment.apiUrl + 'api/ext-worker-user-site', obj)
      .pipe(catchError(this.handleError));
  }

  // Get workers by site and skylark user IDs
  public getWorkersByUserIds(siteId, skylarkUserIds: number[]) {
    return this.http.post(environment.apiUrl + 'api/ext-worker-user-site/by-site/' + siteId + '/by-user-ids', skylarkUserIds)
      .pipe(catchError(this.handleError));
  }

  // Remove Worker from a Site
  public removeWorkerFromSite(workerid) {
    return this.http.delete(environment.apiUrl + 'api/ext-worker-user-site/' + workerid)
      .pipe(catchError(this.handleError));
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      'headers': headers,
      'body': body
    };
    return data;
  }

}
